/**
 * Định dạng và parse số trong input — dấu phẩy ngàn, tùy chọn thập phân.
 */

/**
 * Format số hiển thị trong input (en-US grouping).
 * @param {number|string|null|undefined} numberValue
 * @param {boolean} [allowDecimal=false]
 * @returns {string}
 */
export const formatNumberInput = (numberValue, allowDecimal = false) => {
  if (numberValue === null || numberValue === undefined || numberValue === '') {
    return '';
  }

  const normalizedValue = String(numberValue).replace(/,/g, '');

  if (Number.isNaN(Number(normalizedValue))) {
    return '';
  }

  if (allowDecimal && normalizedValue.includes('.')) {
    const [integerPart, decimalPart = ''] = normalizedValue.split('.');
    const formattedInteger = new Intl.NumberFormat('en-US').format(Number(integerPart || '0'));

    return `${formattedInteger}.${decimalPart}`;
  }

  return new Intl.NumberFormat('en-US').format(Number(normalizedValue));
};

/**
 * Parse chuỗi đã format về số thuần (bỏ dấu phẩy).
 * @param {string|number} formattedValue
 * @param {boolean} [allowDecimal=false]
 * @returns {string}
 */
export const parseFormattedNumber = (formattedValue, allowDecimal = false) => {
  const allowedPattern = allowDecimal ? /[^\d.]/g : /[^\d]/g;
  const parsedValue = String(formattedValue).replace(allowedPattern, '');

  if (!allowDecimal) {
    return parsedValue;
  }

  const hasDecimalPoint = parsedValue.includes('.');
  const [integerPart, ...decimalParts] = parsedValue.split('.');

  if (!hasDecimalPoint) {
    return integerPart;
  }

  return `${integerPart || '0'}.${decimalParts.join('')}`;
};
